import { useParams } from "react-router-dom";
import { HiInformationCircle, HiCog, HiUsers } from "react-icons/hi";
import Sidebar from "components/Sidebar/Sidebar";
import profileAvatar from "assets/img/avatars/avatarSimmmple.png";
import { useUserInfo } from "../_context/UserinfoContext";
import { useTranslation } from "react-i18next";

const RoleSidebar = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { userInfo } = useUserInfo();
  const items = [
    {
      path: `/dashboard/users/${id}`,
      label: t("users.userInfo.sidebar.info"),
      icon: <HiInformationCircle className="h-5 w-5" />,
    },
    {
      path: `/dashboard/users/${id}/roles`,
      label: t("users.userInfo.sidebar.roles"),
      icon: <HiUsers className="h-5 w-5" />,
    },
    {
      path: `/dashboard/users/${id}/settings`,
      label: t("users.userInfo.sidebar.settings"),
      icon: <HiCog className="h-5 w-5" />,
    },
  ];

  const isActiveItems = (itemPath: string) => {
    const currentPath = window.location.pathname;
    if (currentPath === itemPath) return true;
    if (itemPath === `/dashboard/users/${id}`) {
      return currentPath === `/dashboard/users/${id}/`;
    }
    return false;
  };

  const ProfileSection = (
    <div className="flex flex-col items-center justify-center   px-6 py-5">
      <div className="mb-3 flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-gray-200 dark:bg-navy-700">
        <img
          src={profileAvatar}
          alt={t("users.userInfo.profileImageAlt")}
          className="h-16 w-16 object-cover"
        />
      </div>
      <div className="text-center">
        <h3 className="w-[20ch] truncate text-lg font-semibold text-navy-700 dark:text-white">
          {userInfo.name}
        </h3>
      </div>
    </div>
  );

  return (
    <Sidebar
      items={items}
      isActiveItems={isActiveItems}
      ProfileSection={ProfileSection}
    />
  );
};

export default RoleSidebar;
